import { FC, memo } from "react"

const FileUpload: FC = () => {
    return (
        <>
            <svg
              className="min-w-24px"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8.70611 14.3039C8.31614 14.6939 8.31614 15.3261 8.70611 15.7161C9.09522 16.1052 9.72577 16.1062 10.1161 15.7183L11 14.84V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V14.84L13.8804 15.7204C14.2719 16.1119 14.9083 16.1095 15.2984 15.7166C15.6859 15.3264 15.6868 14.6952 15.2989 14.3054L12.7171 11.7106C12.3269 11.3185 11.6923 11.3177 11.3011 11.7089L8.70611 14.3039Z"
                fill="black"
              />
            </svg>
        </>
    )
}

export default memo(FileUpload)